/**
 * @module Authentication
 */

/** */

/**
 * This enum represents the current state of the user session
 */
export let LoginState;

(function (LoginState) {
  LoginState["Pending"] = "Pending";
  LoginState["Unauthenticated"] = "Unauthenticated";
  LoginState["Authenticated"] = "Authenticated";
  LoginState["Unknown"] = "Unknown";
})(LoginState || (LoginState = {}));
//# sourceMappingURL=LoginState.js.map